// PE-6105 — guard authenticated book-appointment route when setting is disabled
import { inject } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { StorageService } from '../services/storage.service';
import { isBookAppointmentEnabled } from '../utils/book-appointment-settings.util';

export const bookAppointmentGuard = (): boolean | UrlTree => {
  const router = inject(Router);
  const storageService = inject(StorageService);
  const userPermissions = storageService.getSessionStorage('user_permissions');

  if (!isBookAppointmentEnabled(userPermissions)) {
    return router.createUrlTree(['/appointments']);
  }
  return true;
};
